import React from "react"

import {Deal} from "@irati/types"
import Saving from "@irati-web/perks/src/components/Saving"
import BoostedSaving from "@irati-web/perks/src/components/BoostedSaving"
import isBoostedPerk from "@irati/deals/helpers/deals/isBoostedPerk"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"
import FlexiRewardPrice from "../../Deal/FlexiRewardPrice"

interface Props extends WithPerkOrReward {
  id?: string,
  allowEarnPointsModal?: boolean,
  deal: Deal
}

const DealImportantInfoSavings: React.FC<Props> = ({deal, allowEarnPointsModal, isRewards}) => {
  if (isRewards) {
    return <FlexiRewardPrice deal={deal} />
  }

  const userSavings = deal.savings?.userSavings
  if (!userSavings) {
    return null
  }

  if (isBoostedPerk(deal)) {
    return (
      <BoostedSaving deal={deal} allowEarnPointsModal={allowEarnPointsModal} />
    )
  }

  return <Saving deal={deal} allowEarnPointsModal={allowEarnPointsModal} />
}

export default withPerkOrReward(DealImportantInfoSavings)
